import { Tooltip as ReactTooltip } from "react-tooltip";

export function Tooltip({ id, children, place = "top", style }) {
  return <ReactTooltip id={id} place={place} style={style} clickable>{children}</ReactTooltip>;
}